import React, { useState } from "react";
import styles from "../Forms.module.scss";
import { IUserSite } from "database";
import classNames from "classnames";
import { format } from "date-fns";

type ViewSiteFormProps = {
	defaultDetails: IUserSite;
	closeForm: () => void;
};

const ViewSiteForm: React.FC<ViewSiteFormProps> = ({
	defaultDetails,
	closeForm,
}) => {
	const [confirmRemovePhotos, setConfirmRemovePhotos] = useState(false);
	const [selectedPhoto, setSelectedPhoto] = useState<string | undefined>();
	const [openPhotoViewer, setOpenPhotoViewer] = useState(false);
	const [photos, setPhotos] = useState(defaultDetails.photos);

	console.log("ViewSite", defaultDetails)
	const values = {
		created: defaultDetails.created === null ? 0 : defaultDetails.created,
		username: defaultDetails.username === null ? "" : defaultDetails.username,
		route: defaultDetails.route === null ? "" : defaultDetails.route,
		siteName: defaultDetails.name === null ? "" : defaultDetails.name,
		altSiteName: defaultDetails.altName === null ? "" : defaultDetails.altName,
		siteType: defaultDetails.siteType === null ? "" : defaultDetails.siteType,
		elr: defaultDetails.elr === null ? "" : defaultDetails.elr,
		siteMileage: defaultDetails.mileage === null ? "" : defaultDetails.mileage,
		latitude:
			defaultDetails.latitude === null
				? ""
				: defaultDetails.latitude.toFixed(4),
		longitude:
			defaultDetails.longitude === null
				? ""
				: defaultDetails.longitude.toFixed(4),
		sitePostCode:
			defaultDetails.postcode === null ? "" : defaultDetails.postcode,
		photos: defaultDetails.photos === null ? [] : defaultDetails.photos,
		comments: defaultDetails.comments === null ? "" : defaultDetails.comments,
	};

	var formatCreated = format(new Date(values.created), "dd/MM/yyyy");

	return (
		<>
			<div className={`${styles.Form}`}>
				<form>
					<label htmlFor="created">Created</label>
					<input readOnly id="created" name="created" value={formatCreated} />
					<label htmlFor="username">Username</label>
					<input
						readOnly
						id="username"
						name="username"
						value={values.username}
					/>
					<label htmlFor="route">Route</label>
					<input readOnly id="route" name="route" value={values.route} />
					<label htmlFor="siteName">Site Name</label>
					<input
						readOnly
						id="siteName"
						name="siteName"
						type="text"
						value={values.siteName}
					/>
					<label htmlFor="altSiteName">Site Alternative Name</label>
					<input
						readOnly
						id="altSiteName"
						name="altSiteName"
						type="text"
						value={values.altSiteName}
					/>
					<label htmlFor="siteType">Site Type</label>
					<input
						readOnly
						id="siteType"
						name="siteType"
						value={values.siteType}
					/>
					<label htmlFor="elr">Site ELR</label>
					<input readOnly id="elr" name="elr" type="text" value={values.elr} />
					<label htmlFor="siteMileage">Site Mileage</label>
					<input
						readOnly
						id="siteMileage"
						name="siteMileage"
						type="text"
						value={values.siteMileage}
					/>
					<label htmlFor="latitude">Site Latitude</label>
					<input
						readOnly
						id="latitude"
						name="latitude"
						type="text"
						value={values.latitude}
					/>
					<label htmlFor="longitude">Site Longitude</label>
					<input
						readOnly
						id="longitude"
						name="longitude"
						type="text"
						value={values.longitude}
					/>
					<label htmlFor="sitePostCode">Site Postcode</label>
					<input
						readOnly
						id="sitePostCode"
						name="sitePostCode"
						type="text"
						value={values.sitePostCode}
					/>
					{values.photos && values.photos.length > 0 && (
						<label htmlFor="sitePhotos">Photos</label>
					)}
					{values.photos && values.photos.length > 0 && (
						<div
							className={styles.photoContainer}
							onClick={() => setOpenPhotoViewer(true)}
						>
							{values.photos.map((photo) => (
								<div className={styles.photoBox}>
									<img src={photo} className={styles.photo} />
								</div>
							))}
						</div>
					)}

					<label htmlFor="comments">Comments</label>
					<input
						readOnly
						id="comments"
						name="comments"
						type="text"
						value={values.comments}
					/>
				</form>
			</div>
			{openPhotoViewer && (
				<div className={styles.photoViewer}>
					<div
						className={styles.closeButton}
						onClick={() => {
							setOpenPhotoViewer(false);
							if (photos !== defaultDetails.photos) {
								setOpenPhotoViewer(false);
							}
						}}
					/>
					{defaultDetails.photos &&
						defaultDetails.photos.map((photo) => (
							<div className={styles.photo}>
								<img src={photo} height={400} width={400} />
							</div>
						))}
				</div>
			)}
		</>
	);
};

export default ViewSiteForm;
